import { render, staticRenderFns } from "./ExtraDocuments.vue?vue&type=template&id=d43f2abe&"
import script from "./ExtraDocuments.vue?vue&type=script&lang=js&"
export * from "./ExtraDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports